import React from "react";

const STAKEHOLDERS = [
  {
    title: "Founders",
    text: "Please apply for your project to be curated among our featured startups",
  },
  {
    title: "Investors",
    text: "Join our select investors for exclusive early access to curated deal-flows",
  },
  {
    title: "Community",
    text: "Join to get exclusive access to alpha, events & being part of our ecosystem",
  },
];

// `[display:block]` instead of Tailwind's `block`: HeaderComponent.css styles
// `.mainHeaderComponent .block` as a white card and would win on specificity.
// `heroCard` is only a hook for the first-fold sizing in HeaderComponent.css,
// which lifts the 160px cap above 992px so the cards grow with the viewport.
const CARD_CLASS =
  "heroCard relative overflow-hidden bg-[#010810] " +
  // Arbitrary values, not `px-5 py-5`: Bootstrap ships its own `.py-5` at 3rem
  // with `!important`, so the plain class was worth either 20px or 48px
  // depending on stylesheet order. `py-[14px]` has no Bootstrap counterpart,
  // so the card's inner height is now a number we actually know.
  "!border !border-[#3a3941] rounded-xl px-[18px] py-[14px] " +
  // `!justify-center` / `!flex-nowrap` because legacy stylesheets redefine a
  // global `.flex` as `space-between` + `wrap`.
  "text-center h-full max-h-[140px] flex flex-col !flex-nowrap !justify-center";

const HeroStakeholderCards = () => (
  // `heroScale` is a hook for the large-screen zoom in HeaderComponent.css.
  // `max-w-5xl` matches the headline block above, so the row of cards ends
  // flush with the paragraph instead of overhanging it by 64px a side.
  <div className="heroScale heroCards w-full max-w-5xl px-4 mt-[60px] mb-0">
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {STAKEHOLDERS.map((item) => (
        <div key={item.title} className={CARD_CLASS}>
          <span className="font-headline font-bold uppercase tracking-[0.08em] text-[#F0B90A] text-lg leading-tight [display:block]">
            {item.title}
          </span>

          <p className="font-body text-[#f0eef2] text-[15px] leading-[1.55] max-w-[26ch] mx-auto mt-2 mb-0">
            {item.text}
          </p>
        </div>
      ))}
    </div>
  </div>
);

export default HeroStakeholderCards;
